<ng-container *ngIf="loading">
  <mapfre-loading></mapfre-loading>
</ng-container>
<ng-container *ngIf="!loading">
  <ng-container *ngFor="let policy of policyDetails">
    <ng-container *ngIf="policy?.policynumber.policyNumber === policyId">
      <mapfre-card [singleCard]="false" [additionalClasses]="
                        'policy-details documents details coverage-margin padding-acmic' + policy?.policyType
                      ">
        <ng-container *ngIf="policy?.policyType === 'AUTO'">
          <app-car-header [policy]="policy"></app-car-header>
        </ng-container>
        <app-dashboard-nav [policyId]="policyId" [policyType] = "policy?.policyType"></app-dashboard-nav>
        <ng-container *ngIf="!isAcmic; else acmicCoverages">
            <div class="margin-top mt32 mb24">
              <ng-container *ngFor="let vehicle of policy?.vehicle | sort: 'vehicleNumber' : 'asc';
                                let index = index;">
                <div class="coverage-margin-outer">
                  <ng-container *ngIf="checkForSingleVehicle(policy?.vehicle); else collapseView">
                    <div class="row vehicle-title mb24">
                      <div class="col c-v-gray-title">{{ vehicle.vehicle | lowercase }}</div>
                    </div>
                  </ng-container>
                  <ng-template #collapseView>
                    <a [id]="'title'+index" class="mapfre link collapse-link vehicle-cov-title" (click)="toggleCollapse(vehicle.coverages,index)"
                      mdbRipple>
           
                      <div class="row vehicle-title">
                        <div class="col c-v-title" [ngClass]="{'col-2d373d lh-24': !isAcmic}">{{ vehicle.vehicle | lowercase }}</div>
                        <div class="col collapse-carot collapse-carot-coverage text-right pl-0 pr-0">
                          <img class="fas fa-caret-down" src="assets/img/images/icon-simple-arrow-down-red.svg" alt="down arrow"/>
                          <img class="fas fa-caret-up" src="assets/img/images/icon-simple-arrow-up-red.svg" alt="up arrow"/>                    
                        </div>
                      </div>
                    </a>
                  </ng-template>
                  <div [id]="'collapse'+index" class="row collapse-content" [ngClass]="{ 'show': policy?.vehicle.length === 1 }">
                   
                    <!-- Required coverage accordion starts -->
                     <div class="w-100">
                       <div class="row ml-0 mr-0 mb-4">
                        <div class="thik-border coverage-margin-mobile col-md-12">
                        <div class="row coverage-title-new">
                          <div class="col-md-12 col-sm-12">
                            Required coverage<span class="tool-tip-align coverage-tooltip ml-2">
                              <!-- <mapfre-tooltip additionalClasses="tool-tip-w" tooltipCopy="There are four coverages required by law in Massachusetts to register a private-passenger
                              vehicle, referred to as “Compulsory Insurance”. They are Bodily Injury to Others (Liability),
                              Damage to Someone Else’s Property (Property Damage), Personal Injury Protection (PIP), and
                              Bodily Injury caused by an Uninsured Auto (Uninsured Motorist)."
                                [placementLocation]="'bottom'" [autoCloseProp]="autoCloseProp"
                                [trigger]="'manual'" [linkTitle]="'Learn more'" [hasCloseButton]="false"
                                [link]="'https://www.mapfreinsurance.com/car-insurance/massachusetts-car-insurance/'">
                                <img src="assets/img/images/icon-info.svg" alt="info icon "  class="coverage-tooltip-icon"/>
                              </mapfre-tooltip>     -->
                              <div class="ctooltip tooltip-positioning" (mouseenter)="onTolltipHover()"
                                [ngClass]="{'tooltip-show': isTooltipVisible}">
                                <img src="assets/img/images/icon-info-red.svg" alt="info icon " class="tooltip-icon" />
                                <app-custom-tooltip [description]="'There are four coverages required by law in Massachusetts to register a private-passenger
                                                            vehicle, referred to as “Compulsory Insurance”. They are Bodily Injury to Others (Liability),
                                                            Damage to Someone Else’s Property (Property Damage), Personal Injury Protection (PIP), and
                                                            Bodily Injury caused by an Uninsured Auto (Uninsured Motorist).'"
                                                            [linkTitle]="'Learn more'"
                                [link]="'https://www.mapfreinsurance.com/car-insurance/massachusetts-car-insurance/'"
                                  (showTooltip)="showToolTip($event)"></app-custom-tooltip>
                              </div>
                            </span>
                          </div>                          
                        </div>
 
                        <ng-container *ngIf="compulsoryCoverages.length">
                        <div class="w-100" *ngFor="let compulsory of compulsoryCoverages[index]; let indx = index;">
                          <div class="thik-border mb-3">                          
                          <a [id]="index+'coverageTitle'+indx" class="mapfre link collapse-link" (click)="requiredCovToggleCollapse(indx, compulsory, index)" mdbRipple>
                            <div class="row ml-0 mr-0 align-items-center cov-innr-pt-pb">
                              <div class="col require-cov-block">
                                <div class="row ">
                                  <div class="col-md-12 col-sm-12 r-c-title">
                                    <span class="fs-16">                                  
                                      {{ splitCoverageName(compulsory.coverageName, 0) }}
                                    </span>
                                    <span class="fs-16 font-weight-normal">
                                      {{ splitCoverageName(compulsory.coverageName, 1) }}
                                    </span>
                                  <div class="row coverage-space">
                                  <div class="col-md-auto col-sm-12 r-c-subtitle c-text-left pr12">
                                    Limit:  
                                    <span class="font-weight-normal">
                                      <ng-container *ngIf="isItHaveLimit(compulsory.coverageTerms, 'Limit');else limitNotApplicable1">
                                        {{ coverageTerm?.termAmount | customCurrency }}
                                      </ng-container>
                                      <ng-template #limitNotApplicable1>
                                        N/A
                                      </ng-template>          
                                    </span>      
                                  </div>
                                  <div class="col-md-auto col-sm-12 r-c-subtitle pl12">
                                    Deductible:
                                    <span class="font-weight-normal">                                      
                                      <ng-container
                                      *ngIf="isItHaveDeductible(compulsory.coverageTerms, 'Deductible', compulsory.coverageName);else deductNotApplicable1">
                                      {{ deductibleTerm?.termAmount | customCurrency }}
                                    </ng-container>
                                    <ng-template #deductNotApplicable1>
                                      N/A
                                    </ng-template>
                                  </span>
                                  </div>
                                  </div>
                                </div>
                                </div>
                              </div>
                              <div class="col collapse-carot collapse-carot-coverage text-right pl-0 pr-2">
                                <img class="fas fa-caret-down" src="assets/img/images/icon-simple-arrow-down-red.svg" alt="down arrow"/>
                                <img class="fas fa-caret-up" src="assets/img/images/icon-simple-arrow-up-red.svg" alt="up arrow"/>
                              </div>
                            </div>
                          </a>
                          <div [id]="index+'coverageCollapse'+indx" class="row collapse-content ml-3 mr-3">
                            <ng-container *ngFor="let vehCoverage of vehicleCoverage">
                              <div *ngIf=" compulsory.coverageName && compulsory.coverageName.toLowerCase() === vehCoverage.coverageName.toLowerCase()">
                                <div class="cov-description">{{vehCoverage.coverageDescription}}</div>                                  
                                <a href="{{vehCoverage.coverageURL}}" target="_blank"  rel="noopener" class="fs-16 mapfre link stuffer-underline red-link dm-sans-medium" [ngClass]="{'lh-21': !isAcmic}">{{vehCoverage.coveragelink}}</a>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                        </div>
                        </ng-container>
                      </div>
                    </div>
                    </div>
                    <!-- Required coverage accordion ends -->
 
                    <!-- Optional coverage accordion starts -->
                     <div class="w-100">
                      <div class="row ml-0 mr-0 mb-4" *ngIf="optionalCoverages[index] && optionalCoverages[index].length">
                        <div class="thik-border col-md-12">
                        <div class="row coverage-title-new">
                          <div class="col-md-12 col-sm-12">
                            Optional coverage<span class="tool-tip-align coverage-tooltip coverage-operational ml-2">
                              <!-- <mapfre-tooltip additionalClasses="tool-tip-w" tooltipCopy="Optional Insurance is additional coverage that provides extra protection beyond the basics required by law and is purchased in addition to Compulsory coverage."
                                [placementLocation]="'bottom'" [autoCloseProp]="autoCloseProp"
                                [trigger]="'manual'" [linkTitle]="'Learn more'" [hasCloseButton]="false"
                                [link]="'https://www.mapfreinsurance.com/car-insurance/massachusetts-car-insurance/'">
                                <img src="assets/img/images/icon-info.svg" alt="info icon" class="coverage-tooltip-icon"/>
                              </mapfre-tooltip> -->
                              <div class="ctooltip tooltip-positioning" (mouseenter)="onOperationalTolltipHover()"
                                [ngClass]="{'tooltip-show': isOperationalTooltipVisible}">
                                <img src="assets/img/images/icon-info-red.svg" alt="info icon " class="tooltip-icon" />
                                <app-custom-tooltip [description]="'Optional Insurance is additional coverage that provides extra protection beyond the
                                 basics required by law and is purchased in addition to Compulsory coverage.'" [linkBlock]="true"
                                 [linkTitle]="'Learn more'"[link]="'https://www.mapfreinsurance.com/car-insurance/massachusetts-car-insurance/'"
                                  (showTooltip)="showOperationalToolTip($event)"></app-custom-tooltip>
                              </div>
                            </span>
                           
                          </div>                          
                        </div>
 
                        <div class="w-100" *ngFor="let optional of optionalCoverages[index]; let ind = index;">
                          <div class="thik-border mb-3">                          
                           <a [id]="index+'optinalTitle'+ind" class="mapfre link collapse-link" (click)="optinalCovToggleCollapse(ind,optional,index)" mdbRipple>
                            <div class="row ml-0 mr-0 align-items-center cov-innr-pt-pb">
                              <div class="col require-cov-block">
                                <div class="row ">
                                  <div class="col-md-12 col-sm-12 r-c-title">
                                    <span class="fs-16">                                  
                                      {{ splitCoverageName(optional.coverageName, 0) }}
                                    </span>
                                    <span class="fs-16 font-weight-normal">
                                      {{ splitCoverageName(optional.coverageName, 1) }}
                                    </span>
                                  <div class="row coverage-space">
                                  <div class="col-md-auto col-sm-12 r-c-subtitle c-text-left pr12">
                                    Limit:  
                                    <span class="font-weight-normal">
                                      <ng-container *ngIf="seeDecCoverages.includes(optional.coverageName); else noSeeDec">
                                        <span class="see-dec-selector-{{index}}{{ind}}">
                                          <a (click)="openPolicyDocuments($event, ind, index)" class="see-dec cove-link">
                                            {{ "See Dec" | translate }}
                                          </a>
                                        </span>
                                      </ng-container>
                                      <ng-template #noSeeDec>
                                        <ng-container *ngIf="isItHaveLimit(optional.coverageTerms, 'Limit');else optLimitNotApplicable">
                                          {{ coverageTerm?.termAmount | customCurrency:optional.coverageName  }}
                                        </ng-container>
                                        <ng-template #optLimitNotApplicable>
                                          N/A
                                        </ng-template>
                                      </ng-template>          
                                    </span>      
                                  </div>
                                  <div class="col-md-auto col-sm-12 r-c-subtitle pl12">
                                    Deductible:
                                    <span class="font-weight-normal">                                      
                                      <ng-container
                                        *ngIf="isItHaveDeductible(optional.coverageTerms, 'Deductible');else optDeductNotApplicable">
                                        {{ deductibleTerm?.termAmount | customCurrency  }}
                                      </ng-container>
                                      <ng-template #optDeductNotApplicable>
                                        N/A
                                      </ng-template>
                                  </span>
                                  </div>
                                  </div>
                                </div>
                                </div>
                              </div>
                              <div class="col collapse-carot collapse-carot-coverage text-right pl-0 pr-2">
                                <img class="fas fa-caret-down" src="assets/img/images/icon-simple-arrow-down-red.svg" alt="down arrow" />
                                <img class="fas fa-caret-up" src="assets/img/images/icon-simple-arrow-up-red.svg" alt="up arrow"/>
                              </div>
                            </div>
                          </a>
                           <div [id]="index+'optinalCollapse'+ind" class="row collapse-content ml-3 mr-3">
                            <ng-container *ngFor="let vehCoverage of vehicleCoverage">
                              <div *ngIf="optional.coverageName && optional.coverageName.toLowerCase() === vehCoverage.coverageName.toLowerCase()">
                                <div class="cov-description">{{vehCoverage.coverageDescription}}</div>                                  
                                <a href="{{vehCoverage.coverageURL}}" target="_blank"  rel="noopener" class="fs-16 mapfre link stuffer-underline red-link dm-sans-medium opacity-light" [ngClass]="{'lh-21': !isAcmic}">{{vehCoverage.coveragelink}}</a>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                      </div>
                    </div>
                    </div>
                    <!-- Optional coverage accordion ends -->
 
                  </div>
                </div>
              </ng-container>
              </div>
        </ng-container>
        <ng-template #acmicCoverages>
            <app-acmic-coverages [policy]="policy"></app-acmic-coverages>
        </ng-template>
     
        <div class="coverage-footer">
            <div class="looking-more cov-ftr" [ngClass]="{'no-border dm-sans-medium': !isAcmic}">Looking for more?</div>
            <div class="c-links">
              <span>Policy changes:</span>
              <ng-container *ngIf="isAcmic; else otherStateLogo">
                <a routerLink="/contact"   class="see-dec">{{ "Contact us" | translate }}</a>
            </ng-container>
            <ng-template #otherStateLogo>
              <a routerLink="/contact"   class="see-dec">{{ "Contact your agent" | translate }}</a>
            </ng-template>
            </div>
            <div class="c-links">
                <span>Full policy information:</span>
                <a routerLink="/my-insurance/{{
                  policy?.policynumber?.policyNumber
                }}/documents"  [queryParams]="{filter: 'pol'}" class="see-dec">{{ "Policy documents" | translate }}</a>
            </div>
            <ng-container *ngIf="!isAcmic">
              <div class="c-links">
                <span>Need more information on your coverages?
                  <a href="https://www.mapfreinsurance.com/car-insurance/massachusetts-car-insurance/" target="_blank"  rel="noopener" class="see-dec learn-more-mobile">{{ "Learn more" | translate }}</a>
                </span>
            </div>
            </ng-container>
        </div>
      </mapfre-card>
    </ng-container>
  </ng-container>
</ng-container>